import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOntluchtingssleutel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M15 16h10v14.84A2.16 2.16 0 0 1 22.84 33h-5.68A2.16 2.16 0 0 1 15 30.84z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.5 28.84V23h1v5.84a2.66 2.66 0 0 1-2.66 2.66h-.76v-1h.76a1.66 1.66 0 0 0 1.66-1.66"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M14 6a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 10a3 3 0 1 1 0-5.999A3 3 0 0 1 14 16"
    />
    <path
      fill="#00C5F2"
      d="M26 6a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 10a3 3 0 1 1 0-5.999A3 3 0 0 1 26 16"
    />
    <path
      fill="#85E3F9"
      d="M20 17s-4 0-4 4v9.56A1.41 1.41 0 0 0 17.42 32H20"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M14 11.5a2.5 2.5 0 1 0 2.5 2.5h1a3.5 3.5 0 1 1-3.5-3.5zM25 10.5a2.5 2.5 0 0 0-2.5 2.5h-1A3.5 3.5 0 0 1 25 9.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOntluchtingssleutel);

export default ForwardRef;
